import React from "react";
import {Breadcrumb, Layout, Menu, message} from "antd";
import { UserOutlined, LaptopOutlined, NotificationOutlined,ReadOutlined,HourglassOutlined } from '@ant-design/icons';
import {UserDescriptions} from "./UserDescriptions";
import {getHostAddress,getFrontEndAddress} from "../../Tool/UtileFun"
import {FileViewerTool} from "../Util/fileViewer/FileViewerTool";
import $ from  'jquery'
import {teacherPage,studentPage} from "../../Tool/PageJurisdiction"
import cookie from "react-cookies";
import { Typography, Space } from 'antd';
import backgroundImg from "../IMG/mainBackground.png";
import robotLogo from "../IMG/robotLogo.png";


export function UserLayout(){

    const experimentPage = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/user/experi"
    }
    const userInfoPage = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/user/userInfo"
    }
    const resourcesPage = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/user/resources"
    }
    const homeworkCorrection = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/user/homeworkCorrection"
    }
    const knowledgeLibrary = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/user/knowledgeLibrary"
    }
    const classTablePage = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/user/classTable"
    }
    const studentTablePage = ()=>{
        window.location.href="http://"+getFrontEndAddress()+"/user/studentTable"
    }
    const outLogin = () =>{
        const username = "username"
        const classId = "classID"
        const role = "role"
        const userId = "userId"
        cookie.remove(userId)
        cookie.remove(username)
        cookie.remove(role)
        cookie.remove(classId)
        window.location.href="http://"+getFrontEndAddress()+"/user/"
    }

    const { Text, Link } = Typography;
    const role = "role"
    const { SubMenu } = Menu;
    const { Header, Content, Sider } = Layout;
    const layout = (
        <Layout>
            <Header className="header">
                <div className="logo" />
                {/*<Menu theme="dark" mode="horizontal" defaultSelectedKeys={['1']}>*/}
                {/*    <Menu.Item key="1">RPA审计机器人课程平台</Menu.Item>*/}
                {/*    /!*<Menu.Item key="2">nav 2</Menu.Item>*/}
                {/*    <Menu.Item key="3">nav 3</Menu.Item>*!/*/}
                {/*</Menu>*/}
                <div style={{
                    //zIndex: 99999,
                    position: "absolute",
                    backgroundImage: `url(${robotLogo})`,
                    backgroundSize:"100% 100%",
                    color:"white"
                }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                </div>
                <div style={{
                    //zIndex: 99999,
                    position: "absolute",
                    color:"white",
                    fontSize:"30px",
                    margin:"0 0 0 530px",
                    fontFamily: "STKaiti"
                }}>RPA审计机器人课程平台</div>
            </Header>
            <Layout>
                <Sider width={200} className="site-layout-background">
                    <Menu
                        mode="inline"
                        defaultSelectedKeys={['3']}
                        defaultOpenKeys={['sub1','sub2','sub3']}
                        style={{ height: '100%', borderRight: 0 }}
                    >
                        <SubMenu key="sub1" icon={<HourglassOutlined />} title="实验管理">
                            {
                                studentPage({role:cookie.load(role),label:<Menu.Item key="1" onClick={experimentPage}>实验任务</Menu.Item>})
                            }
                            {
                                teacherPage({role:cookie.load(role),label:<Menu.Item key="2" onClick={resourcesPage}>实验资源</Menu.Item>})
                            }
                            <Menu.Item key="5" onClick={knowledgeLibrary}>知识库</Menu.Item>
                        </SubMenu>
                        {
                            teacherPage({role:cookie.load(role),label:<SubMenu key="sub3" icon={<ReadOutlined />} title="作业管理">
                                    <Menu.Item key="4" onClick={homeworkCorrection}>作业批改</Menu.Item>
                                </SubMenu>})
                        }
                        <SubMenu key="sub2" icon={<UserOutlined />} title="基础管理">
                            <Menu.Item key="3" onClick={userInfoPage}>个人信息</Menu.Item>
                            {
                                //teacherPage({role:cookie.load(role),label:<Menu.Item key="12" onClick={classTablePage}>班级管理</Menu.Item>})
                            }
                            {
                                teacherPage({role:cookie.load(role),label:<Menu.Item key="11" onClick={studentTablePage}>学生管理</Menu.Item>})
                            }
                            <Menu.Item key="10" onClick={outLogin}><Text type="danger">退出</Text></Menu.Item>
                        </SubMenu>
                    </Menu>
                </Sider>
                <Layout style={{
                    padding: '0 24px 24px',
                    backgroundImage: `url(${backgroundImg})`,
                    backgroundSize:"100% 100%"
                }}>
                    <Breadcrumb style={{ margin: '16px 0' }}>
                        {/*<Breadcrumb.Item>Home</Breadcrumb.Item>*/}
                        {/*<Breadcrumb.Item>List</Breadcrumb.Item>*/}
                        {/*<Breadcrumb.Item>App</Breadcrumb.Item>*/}
                    </Breadcrumb>
                    <Content
                        className="site-layout-background"
                        style={{
                            //overflow: 'initial',
                            minHeight: document.body.clientHeight
                        }}
                        // style={{
                        //     marginTop: 17,
                        //     padding: 24,
                        //     //minHeight: "100%",
                        //     height: 615,
                        // }}
                    >

                        <UserDescriptions></UserDescriptions>
                        {/*<iframe*/}
                        {/*    src='https://view.officeapps.live.com/op/view.aspxsrc=http://localhost:8081/experimentResources/generalResources/MySQL讲义PPT.pptx'*/}
                        {/*    width='100%' height='100%' frameBorder='1'>*/}
                        {/*</iframe>*/}
                        {/*<iframe*/}
                        {/*    src="//ow365.cn/?i=18679&&furl=http://98.151.10.97:8081/experimentResources/generalResources/MySQL讲义PPT.pptx"*/}
                        {/*    width="100%"*/}
                        {/*    height="100%"*/}
                        {/*    frameborder="0">*/}
                        {/*</iframe>*/}
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    )

    return(
        layout
    )
}
